import { Coordinate } from "./coordinate";
import L from 'leaflet';

export class PointOfInterest {
    private _popup: L.Marker;
    private _marker: L.Marker;

    get popup(): L.Popup { return this._popup; }
    get marker(): L.Marker { return this._marker; }

    id: number;
    position: Coordinate;
    name: string;
    type: POIType;
    get localizedType() {
        switch (this.type) {
            case POIType.Mall:
            case POIType.Supermarket:
                return 'магазин';
            case POIType.Kindergarten:
            case POIType.School:
            case POIType.University:
                return 'учебное заведение';
            case POIType.Hospital:
            case POIType.Clinic:
            case POIType.Doctor:
                return 'медицинское учреждение';
            case POIType.Police:
                return 'полиция';
            case POIType.SubwayStation:
                return 'метро';
            case POIType.RailwayStation:
                return 'вокзал';
            case POIType.Cafe:
                return 'кафе';
            case POIType.Cinema:
                return 'кинотеатр';
            case POIType.Theatre:
                return 'театр';
            case POIType.Pub:
                return 'паб';
            case POIType.Nightclub:
                return 'ночной клуб';
            case POIType.Restaurant:
                return 'ресторан';
            case POIType.Bar:
                return 'бар';
            default:
                return '';
        }
    }

    isSelected: boolean;
    isEnabled: boolean;

    select(): void {
        this.isSelected = true;
        if (!this._marker._icon)
            return;
        L.DomUtil.addClass(this._marker._icon, 'selected-icon');
    }

    unselect() {
        this.isSelected = false;
        if (!this._marker._icon)
            return;
        L.DomUtil.removeClass(this._marker._icon, 'selected-icon');
    }

    enable() {
        this.isEnabled = true;
        if (!this._marker._icon)
            return;
        L.DomUtil.removeClass(this._marker._icon, 'disabled-map-object');
    }

    disable() {
        this.isEnabled = false;
        if (!this._marker._icon)
            return;
        L.DomUtil.addClass(this._marker._icon, 'disabled-map-object');
    }

    init() {
        let path: string = '';

        this.isEnabled = true;

        switch (this.type) {
            case POIType.Mall:
            case POIType.Supermarket:
                path = '../../assets/mall.svg';
                break;
            case POIType.Kindergarten:
            case POIType.School:
            case POIType.University:
                path = '../../assets/education.svg';
                break;
            case POIType.Hospital:
            case POIType.Clinic:
            case POIType.Doctor:
            case POIType.Police:
                path = '../../assets/hospital.svg';
                break;
            case POIType.SubwayStation:
                path = '../../assets/metro.svg';
                break;
            case POIType.RailwayStation:
                path = '../../assets/railway.svg';
                break;
            case POIType.Cafe:
            case POIType.Cinema:
            case POIType.Theatre:
            case POIType.Pub:
            case POIType.Nightclub:
            case POIType.Restaurant:
            case POIType.Bar:
                path = '../../assets/cafe.svg';
                break;
            default:
                //TODO set default icon
                path = '../../assets/tram.png';
        }

        let position = [
            this.position.latitude,
            this.position.longitude
        ];
        let icon = L.icon({
            iconUrl: path,
            iconSize: [30, null]
        });
        let options = {
            icon: icon,
            title: this.name,
            alt: this.type,
            riseOnHover: true
        };
        let popupOptions = {
            closeButton: false,
            autoPanPadding: 1
        };
        // this._popup = L.popup(popupOptions)
        //     .setContent(this.publicNumber)
        //     .setLatLng(position);
        this._marker = L.marker(position, options);
        //     .bindPopup(this._popup);
    }
}

export enum POIType {
    Mall = 'mall',
    Supermarket = 'supermarket',
    Hospital = 'hospital',
    Doctor = 'doctors',
    Clinic = 'clinic',
    Police = 'police',
    University = 'university',
    School = 'school',
    Kindergarten = 'kindergarten',
    SubwayStation = 'subway',
    RailwayStation = 'station',
    Cafe = 'cafe',
    Cinema = 'cinema',
    Nightclub = 'nightclub',
    Theatre = 'theatre',
    Bar = 'bar',
    Pub = 'pub',
    Restaurant = 'restaurant'
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/poi.ts